/** 与 CRA public/ 根路径一致的静态资源 URL（支持 homepage 子路径） */
export const HERO_BACKGROUND_MP4 = `${process.env.PUBLIC_URL || ''}/background-video.mp4`;
